import { Text } from '@react-pdf/renderer'
import { GridVariableValue } from '@ulysses-inc/harami_api_client'
import { FC } from 'react'
import { gridLayoutTableBodyCell } from '../../../shared/styles'

type Props = {
  value?: GridVariableValue['value']
}

export const TableBodyCellGridVariable: FC<Props> = ({ value }) => {
  return (
    <Text
      style={[
        gridLayoutTableBodyCell.baseTableBodyCell,
        gridLayoutTableBodyCell.tableBodyCell,
      ]}
    >
      {value === '' ? 'ー' : value}
    </Text>
  )
}
